import * as React from "react";
import { RouteComponentProps } from 'react-router-dom';
import { Layout } from 'antd';
import PublicFooter from "./PublicFooter";
import '../Layout.less';
import 'src/pages/public/Public.less';
import GeneralHeader from "src/layouts/GeneralHeader";

const { Content } = Layout;

class PublicLayout extends React.Component<{}, {}> {
    render() {
        return <Layout className="public">
            <GeneralHeader
                renderEmulationBanner={false}
                renderFullscreenToggle={true}
                renderLanguageToggle={true}
                renderAudioToggle={false}
                renderPlanetBox={false}
                renderBackToSpaceStation={false}
            />
            <Layout>
                <Content>
                    {this.props.children}
                </Content>
            </Layout>
            <PublicFooter />
        </Layout>;
    }
}

export default PublicLayout;



// WEBPACK FOOTER //
// ./src/layouts/public/PublicLayout.tsx